import HttpService from '../../../core/rest/http.service';
import { stringToBoolean } from '../../../core/helpers/type-conversion.helper';
export async function loadDocuments(filter) {
    let parameters = {};
    let documents = null; // true -> only documents, false -> only WO, null -> both
    if (filter.isWo === true) {
        documents = false;
    }
    else if (filter.isWo === false) {
        documents = true;
    }
    parameters = {
        q: filter.query,
        anyCategoryIds: [filter.categoryId],
        // allCategoryIds: [filter.categoryId],
        categorySlug: filter.categorySlug ? filter.categorySlug : undefined,
        folderId: filter.documentFolderId ? filter.documentFolderId.split(',') : undefined,
        unitSlug: filter.unitSlug ? filter.unitSlug : undefined,
        groupId: filter.groupId,
        fileEntryTypeIds: filter.fileEntryTypeId ? [filter.fileEntryTypeId] : undefined,
        year: filter.year ? parseInt(filter.year) : undefined,
        valid: stringToBoolean(filter.valid),
        showSiteUrl: stringToBoolean(filter.showSiteUrl),
        documents,
        page: filter.pager.page,
        pageSize: filter.pager.perPage,
        order: filter.order,
    };
    Object.entries(parameters).forEach(([key, value]) => {
        if (value === undefined)
            delete parameters[key];
    });
    const endpoint = "/search/dokumenty-mesta-and-documents";
    return HttpService.get(endpoint, parameters);
}
